import { getCurrentInstance } from "@vue/composition-api";
export const useRouter = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error("must be called in setup");
  return {
    router: vm.proxy.$router
  };
};